// Tracking Package
function trackPackage() {
    const trackingNumber = document.getElementById("trackingInput").value;
    if (trackingNumber?.trim() === "") {
        alert("Veuillez entrer un numéro d'expédition");
        return;
    }
    alert(`Recherche de l'expédition: ${trackingNumber}`);
}

// Newsletter subscription
function subscribeNewsletter() {
    const email = document.getElementById("newsletterEmail").value;
    if (email?.trim() === "") {
        alert("Veuillez entrer votre email");
        return;
    }
    if (!email.includes("@")) {
        alert("Veuillez entrer un email valide");
        return;
    }
    alert(`Merci de vous être abonné avec: ${email}`);
    document.getElementById("newsletterEmail").value = "";
}

// Go to Top Button
const goToTopBtn = document.getElementById("goToTopBtn");

window.addEventListener("scroll", function () {
    if (window.pageYOffset > 300) {
        goToTopBtn?.classList.add("visible");
    } else {
        goToTopBtn?.classList.remove("visible");
    }
});

function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
}

goToTopBtn?.addEventListener("click", function () {
    scrollToTop();
});


// Allow Enter key for tracking
document
    .getElementById("trackingInput")
    ?.addEventListener("keypress", function (event) {
        if (event.key === "Enter") {
            trackPackage();
        }
    });

// Allow Enter key for newsletter
document
    .getElementById("newsletterEmail")
    ?.addEventListener("keypress", function (event) {
        if (event.key === "Enter") {
            subscribeNewsletter();
        }
    });

// Smooth scroll for navigation links
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor?.addEventListener("click", function (e) {
        e.preventDefault();
        const href = this.getAttribute("href");
        if (
            href !== "#" &&
            href !== "#login" &&
            href !== "#register" &&
            href !== "#profile"
        ) {
            const target = document.querySelector(href);
            if (target) {
                target.scrollIntoView({
                    behavior: "smooth",
                });
            }
        }

        // Close navbar on mobile after clicking a link
        const navbarCollapse = document.getElementById("navbarNav");
        if (navbarCollapse.classList.contains("show")) {
            const bsCollapse = new bootstrap.Collapse(navbarCollapse);
            bsCollapse.hide();
        }
    });
});
